import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import { grey } from '@mui/material/colors';

const BlackButton = styled(Button)({
    color: grey[900],
    backgroundColor: grey[50],
    '&:hover': {
      backgroundColor: grey[200],
    },
  });

export default BlackButton;